import FontFaceObserver from 'fontfaceobserver';

// Preload common fonts
export const preloadFonts = () => {
  const fonts = [
    'PlusJakartaSans-Regular',
    'PlusJakartaSans-Bold',
    'Montserrat-Regular',
    'Montserrat-Bold',
    'Montserrat-Italic',
    'Tinos-Regular',
    'Tinos-Bold',
    'Tinos-Italic',
    'OpenSans-Regular',
    'OpenSans-Bold',
    'OpenSans-Italic',
    'FunnelSans-Regular',
    'FunnelSans-Bold',
    'FunnelSans-Italic',
    'Rubik-Regular',
    'Rubik-Bold',
    'Rubik-Italic',
    'IBMPlexSerif-Regular',
    'IBMPlexSerif-Bold',
    'IBMPlexSerif-Italic',
    'Spectral-Regular',
    'Spectral-Bold',
    'Spectral-Italic',
    'Roboto-Regular',
    'Roboto-Bold',
    'Roboto-Italic',
    'Poppins-Regular',
    'Poppins-Bold',
    'Poppins-Italic'
  ];
  
  return Promise.all(
    fonts.map(font => {
      const observer = new FontFaceObserver(font);
      return observer.load(null, 5000).catch(err => {
        console.warn(`Font ${font} failed to load:`, err);
      });
    })
  );
};